import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Box, CircularProgress } from '@mui/material';
import usePermissions from '../../hooks/usePermissions';

function RequirePermission({
    permission,
    anyOf,
    allOf,
    children,
}) {
    const { t } = useTranslation();
    const { has, hasAny, hasAll, loading } = usePermissions();

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="40vh">
                <CircularProgress />
            </Box>
        );
    }

    const allowed = (() => {
        if (permission) {
            return has(permission);
        }
        if (anyOf) {
            return hasAny(anyOf);
        }
        if (allOf) {
            return hasAll(allOf);
        }
        return true;
    })();

    if (!allowed) {
        return (
            <Box p={3}>
                <Alert severity="warning">
                    {t('app.permissions.accessDenied')}
                </Alert>
            </Box>
        );
    }

    return children;
}

export default RequirePermission;
